const queryKeys = {
  all: (partyId: string) => ['risk-objects', partyId] as const,

  lists: (partyId: string) => [...queryKeys.all(partyId), 'lists'] as const,
  details: (partyId: string) => [...queryKeys.all(partyId), 'details'] as const,

  list: (partyId: string, filter: unknown) =>
    [...queryKeys.lists(partyId), filter] as const,
  byId: (partyId: string, id: string) =>
    [...queryKeys.details(partyId), id] as const,
};

export default queryKeys;
